<template lang="pug">
  div(class="qcw-comment__attachment")
    audio(
      v-if="fileType == 'audio'"
      :src="comment.payload.url"
      width="100%"
      controls) Your browser does not support the audio element.
    video(
      :controlsList="controlsListValue"
      controls
      v-if="fileType == 'video'"
      muted
      :src="videoSource"
      width="100%") Sorry, your browser doesn't support embedded videos.
    image-loader(
      v-else
      :comment="comment"
      :message="fileSource"
      :on-click-image="onClickImage"
      :thumbnailMode="true"
      :callback="callback")

    comment-render(:text="comment.payload.caption" v-if="comment.payload.caption != '' && !isInteractiveMessage")

    //- USER COMMENT INSTAGRAM POST
    div(v-if="comment.extras && (comment.extras.type == 'video_ig_comment' || comment.extras.type == 'image_ig_comment' || isRedownloadAttachment)"
      class="reply-wrapper" :class="{'reply-wrapper--redownload': isRedownloadAttachment}")
      comment-render(:text="comment.extras.reply" v-if="comment.extras.type !== 'redownload_attachment' && comment.extras.reply && comment.extras.reply !== ''")
      comment-redownload(message="This attachment file was sent in the previous message by " :sender="comment.extras.sender" :timestamp="comment.extras.timestamp" v-if="isRedownloadAttachment")
</template>

<script>
import ImageLoader from './ImageLoader';
import CommentRender from './CommentRender';
import CommentRedownload from './CommentRedownload';
import Icon from './Icon';

export default {
  name: 'FileAttachment',
  components: { ImageLoader, CommentRender, Icon, CommentRedownload },
  props: ['comment', 'onClickImage', 'callback'],
  data() {
    return {
      fileType: null,
      controlsListValue: '',
    };
  },
  computed: {
    isInteractiveMessage() {
      return this.comment.extras && this.comment.extras.type === 'interactive_wa' && this.comment.extras.sub_type === 'reply_buttons';
    },
    fileSource() {
      if (this.isInteractiveMessage) return this.comment.extras.header.value;
      return this.comment.message;
    },
    videoSource() {
      if (this.isInteractiveMessage) return this.comment.extras.header.value;
      return this.comment.payload.url;
    },
    isRedownloadAttachment() {
      return this.comment.extras.type === 'redownload_attachment';
    },
  },
  mounted() {
    if (this.isInteractiveMessage) {
      this.fileType = this.checkfileType(this.comment.extras.header);
    } else {
      this.fileType = this.checkfileType(this.comment.payload);
    }
  },
  methods: {
    checkfileType(payload) {
      const extras = this.comment.extras;
      const isAudio = extras.source === 'ig' && extras.type === 'audio';
      const isVideo = extras.source === 'ig' && extras.type === 'video';
      const splittedURL = this.isInteractiveMessage ? payload.value.split('.') : payload.url.split('.');
      const ext = splittedURL[splittedURL.length - 1].toLowerCase();
      const imageExts = ['jpg', 'jpeg', 'gif', 'webp', 'png'];
      const videoExts = ['mov', 'mp4', 'webm'];
      const audioExts = ['mp3', 'oga', 'ogg', 'm4a'];
      if (imageExts.includes(ext)) return 'image';
      if (videoExts.includes(ext) || isVideo) {
        const qismoRawData = localStorage['qismo-data'];
        if (qismoRawData) {
          const qismoData = JSON.parse(qismoRawData);
          const isAgent = qismoData && qismoData.user && qismoData.user.type === 2;
          const appConfig =  window.appAdditionalConfig ?  window.appAdditionalConfig : false;
          const agentCantDownload = !(appConfig && appConfig.agentCanDownloadVideo);
          if (isAgent && agentCantDownload) {
            this.controlsListValue = 'nodownload';
          }
        }
        return 'video';
      }
      if (audioExts.includes(ext) || isAudio) return 'audio';
      if (extras.source === 'ig') return 'ic-ig-attachment';
      return 'ic-file-attachment';
    },
  },
};
</script>

<style lang="stylus">
.qcw-comment__attachment
  overflow hidden
  border-radius 4px
  video
    max-height 150px
</style>



// WEBPACK FOOTER //
// src/components/FileAttachment.vue